<div class="d-flex gap-3 dashboard-header">
	@if (is_new_vat_number) {
		<app-gen-select
			[actualObj]="this"
			fieldName="vat_number"
			[options]="vat_numbers"
			(changeEvent)="getData()"
			class="pad-btns"
		/>
	}
	@if (freq == "yearly") {
		<div class="d-flex gap-3">
			<div class="colstat-small">
				<label>{{ "year_from" | langVal }}</label>
				<app-gen-select
					[options]="years"
					[actualObj]="this"
					fieldName="yearFrom"
					(changeEvent)="getData()"
				/>
			</div>
			<div class="colstat-small">
				<label>{{ "year_to" | langVal }}</label>
				<app-gen-select
					[options]="years"
					[actualObj]="this"
					fieldName="yearTo"
					(changeEvent)="getData()"
				/>
			</div>
		</div>
	} @else {
		<app-gen-button-group
			[actualObj]="this"
			fieldName="timeRange"
			optionsListName="graphs_time_ranges"
			(changeEvent)="getData()"
			class="pad-btns"
		/>
	}
	<app-gen-button-group
		[actualObj]="this"
		fieldName="freq"
		optionsListName="graphs_freqs"
		(changeEvent)="freqChange(); getData()"
		class="pad-btns"
	/>
</div>

<div class="dashboard">
	<app-spin-or-content [isSpin]="isLoading">
		@for (outputGraph of outputGraphs; track outputGraph) {
			<div class="container">
				<div class="title">
					<h2>{{ outputGraph.lang | langVal }}</h2>
					<div class="d-flex gap-3">
						@for (
							field of fields[outputGraph.name] | keyvalue;
							track field.key
						) {
							<!-- <div> -->
							<label>
								<input
									type="checkbox"
									[checked]="fields[outputGraph.name][field.key]"
									(change)="
										fields[outputGraph.name][field.key] = $event.target.checked;
										renderData()
									"
								/>
								{{ field.key | langVal }}</label
							>
							<!-- </div> -->
						}
					</div>
				</div>
				@if (!isLoading) {
					<ngx-charts-bar-vertical-2d
						[scheme]="colorScheme"
						[results]="data[outputGraph.name]"
						[gradient]="true"
						[xAxis]="true"
						[yAxis]="true"
						[legend]="false"
						[showXAxisLabel]="true"
						[showYAxisLabel]="false"
						[xAxisLabel]="freq | langVal"
						[yAxisLabel]="outputGraph.lang | langVal"
						[legendTitle]="'columns' | langVal"
						(select)="onSelect($event)"
						(activate)="onActivate($event)"
						(deactivate)="onDeactivate($event)"
					>
					</ngx-charts-bar-vertical-2d>
				}
			</div>
		}
	</app-spin-or-content>
	<!-- IF PARTICULAR VIEW IS NEEDED, ADD [view]="view" TO <ngx-charts-bar-horizontal-2d> -->
	<!-- <div class="container">
		<div class="title">
			<h2>
				{{ "debts" | langVal }}
				<button
					class="btn btn-icon"
					titleLang="report_defs"
					[icon]="'leftArrow'"
					style="min-height: 20px"
				></button>
			</h2>
			<button
				class="btn btn-icon"
				titleLang="debts"
				[icon]="'settings2'"
				style="min-height: 20px"
			></button>
		</div>
		<div class="content">
			<div class="dash-table">
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="patient"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>אנה פרויד</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="patient"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>אנה פרויד</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="patient"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>אנה פרויד</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="patient"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>אנה פרויד</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="payor"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>קופת חולים</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
							titleLang="patient"
							class="btn btn-icon"
							tabindex="12"
							icon="patient"
						></button>
						<span>אנה פרויד</span>
					</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container">
		<div class="title">
			<h2>
				{{ "debts" | langVal }}
				<button
					class="btn btn-icon"
					titleLang="report_defs"
					[icon]="'leftArrow'"
					style="min-height: 20px"
				></button>
			</h2>
			<button
				class="btn btn-icon"
				titleLang="debts"
				[icon]="'settings2'"
				style="min-height: 20px"
			></button>
		</div>
		<div class="content">
			<div class="dash-table">
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>אנה פרויד</div>
					<div>500</div>
					<div>&#64;</div>
					<div>SMS</div>
					<div>חשבונית</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
	<div class="container"></div>
</div> -->

	<!-- <div class="dashboard d-grid delete"></div>
</div> -->
</div>
